import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { generateGreetings } from 'srcReact/helpers/utils'
import styles from './styles.module.scss'
import { appConstantSettings } from 'srcReact/appConstantSettings'

export default function WelcomeBanner({ firstname, isNative }) {
  const { t } = useTranslation()

  const [currentIndex, setCurrentIndex] = useState(0)
  const quoteRef = useRef([])
  const greetingRef = useRef(null)

  const [quotes, setQuotes] = useState([
    t('welcomeBanner.sub11'),
    t('welcomeBanner.sub12'),
    t('welcomeBanner.sub13'),
    t('welcomeBanner.sub14'),
    t('welcomeBanner.sub15'),
    t('welcomeBanner.sub16'),
    t('welcomeBanner.sub17'),
    t('welcomeBanner.sub18'),
    t('welcomeBanner.sub19'),
    t('welcomeBanner.sub10')
  ])

  useEffect(() => {
    greetingRef.current.classList.add('active')
  }, [])

  useEffect(() => {
    const changeTitle = () => {
      const isGreetingVisible = greetingRef.current.classList.contains('active')
      if (isGreetingVisible) {
        greetingRef.current.classList.remove('active')
      }
      quoteRef.current[currentIndex].classList.remove('active')
      const randomIndex = Math.floor(Math.random() * quotes.length)
      quoteRef.current[randomIndex].classList.add('active')
      setCurrentIndex(randomIndex)
    }

    const intervalId = setInterval(changeTitle, appConstantSettings.WELCOME_BANNER_INTERVAL)
    return () => clearInterval(intervalId)
  }, [currentIndex])

  return (
    <div data-testid='welcome-banner' className={`${styles.banner} ${isNative && styles.nativeBanner}`}>
      <h1 ref={greetingRef} className={`${styles.title}`}>{`${generateGreetings()} ${firstname} ${':)'}`}</h1>
      {quotes.map((quote, index) => (
        <h1 ref={(el) => (quoteRef.current[index] = el)} className={`${styles.title}`}>
          {quote}
        </h1>
      ))}
    </div>
  )
}

WelcomeBanner.propTypes = {
  firstname: PropTypes.string,
  isNative: PropTypes.bool
}

WelcomeBanner.defaultProps = {
  firstname: '',
  isNative: false
}
